import { render, staticRenderFns } from "./qc_inspection.vue?vue&type=template&id=6a960c53"
import script from "./qc_inspection.vue?vue&type=script&lang=js"
export * from "./qc_inspection.vue?vue&type=script&lang=js"
import style0 from "./qc_inspection.vue?vue&type=style&index=0&id=6a960c53&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports